import React, { useEffect } from "react";

import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@/store/store";

import TicketDetailAppBar from "../TicketDetailContainer/TicketDetailAppBar";
import PostingDetail from "./PostingDetail";
import { fetchPostingByIdThunk } from "../../modules/postings/postingDetail/postingDetailOperations";
import { postingDetailSelectors } from "../../modules/postings/postingDetail/postingDetailSlice";
import DocumentLayout from "../../components/Layouts/DocumentLayout";
import PageLoader from "../../components/Common/PageLoader";

const route = "/postings/:postingId";

function PostingDetailContainer() {
  const dispatch = useAppDispatch();
  const { postingId } = useParams();
  const posting = useAppSelector((state) =>
    postingDetailSelectors.selectPostingDetail(state, postingId),
  );

  useEffect(() => {
    dispatch(fetchPostingByIdThunk(Number(postingId)));
  }, [dispatch, postingId]);

  return (
    <div>
      <TicketDetailAppBar />
      <DocumentLayout>
        {posting.isLoading ? <PageLoader /> : <PostingDetail item={posting} />}
      </DocumentLayout>
    </div>
  );
}

PostingDetailContainer.route = route;

export default PostingDetailContainer;
